import { SET_SELECTED_CATEGORY_SLUG } from '../../actions/planCategories'

let planCategories = (state = {}, action) => {
  switch (action.type) {
    case SET_SELECTED_CATEGORY_SLUG:
      return Object.assign({}, state, {
        selectedCategorySlug: action.slug
      })
    default:
      return state
  }
}

export default planCategories
